module.exports = __webpack_public_path__ + "static/media/modal_error_bg.0289f0e0.png";